var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRancher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "128px",
    height: "128px",
    fill: "#2453FF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127,47.4l-1.4-8.2c-0.4-2.6-1.5-4.8-2.3-4.8c-0.8,0-1.5,2.2-1.5,4.9v2.2c0,2.6-2.2,4.9-4.9,4.9h-2.2 c-0.2,0-0.3,0-0.4,0v5.9c0.2,0,0.3,0,0.4,0h8.1C125.6,52.1,127.4,50,127,47.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6,40.4H94.6c-0.1,0-0.2,0-0.3,0H80.8c-0.2,0-0.3,0-0.4,0.1v-1.3c0-2.6-0.7-4.9-1.5-4.9 c-0.8,0-1.8,2.2-2.3,4.8l-1.4,8.2c-0.4,2.6,1.4,4.8,4.1,4.8h8.1c0.8,0,1.6-0.1,2.3-0.3c-0.3,1.4-1.4,2.4-2.9,2.4H75.4 c-1.8,0-3.2-1.7-2.9-3.5l1.2-6.9c0.3-1.8-1.1-3.5-2.9-3.5H14.3c-1.2,0-2.2,0.7-2.7,1.8L1,58.4c-0.2,0.3-0.2,0.6,0.1,0.9l2,2.4 c0.3,0.3,0.7,0.3,1,0.1l7.2-5.7v34.5c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3v-12c0-1.7,1.3-3,3-3h39.9c1.7,0,3,1.3,3,3v12 c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3V77.7h-8.5c-2.6,0-4.9-2.2-4.9-4.9v-8.3c0-1.6,0.8-3,1.9-3.9v9.9c0,2.6,2.2,4.9,4.9,4.9h13.1 c2.6,0,4.9-2.2,4.9-4.9V45.4C112.5,42.6,110.3,40.4,107.6,40.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRancher);
export default __webpack_public_path__ + "static/media/rancher.14d7597a043009b6bd4aa983ad686abd.svg";
export { ForwardRef as ReactComponent };